/* eslint-disable import/no-anonymous-default-export */
import { AxiosWrapper } from "utils/axios.helper";
import { HandleError } from "./errorHandler.service";

const GetCollections = (filters?: any) => {
    return AxiosWrapper({
        url: "/collections",
        method: "get",
        params: filters
    }).catch((error) => {
        return HandleError(error);
    });
}

export {
    GetCollections,
};